// GlobalLoaderContext.js
import { ProgressSpinner } from "primereact/progressspinner";
import React, { createContext, useState, useContext, useCallback } from "react";

import { Loader } from "rsuite";

// Create a context for the loader
const LoaderContext = createContext();

// Provider component
export const LoaderProvider = ({ children }) => {
  const [loaderConfig, setLoaderConfig] = useState({
    visible: false,
    shadingColor: "rgba(0,0,0,0.4)",
    position: { of: window },
    showIndicator: true,
    shading: true,
    hideOnOutsideClick: false,
  });

  const showLoader = useCallback((config = {}) => {
    setLoaderConfig((prevConfig) => ({
      ...prevConfig,
      visible: true,
      ...config,
    }));
  }, []);

  const hideLoader = useCallback(() => {
    setLoaderConfig((prevConfig) => ({
      ...prevConfig,
      visible: false,
    }));
  }, []);

  return (
    <>
      <LoaderContext.Provider value={{ showLoader, hideLoader }}>
        {children}
        {loaderConfig.visible && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0,0,0,0.4)", // Optional shading
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999, // Ensure it appears on top
            }}
          >
            <Loader size="md" />
          </div>
        )}
      </LoaderContext.Provider>
    </>
  );
};

// Hook to use the loader in other components
export const useLoader = () => useContext(LoaderContext);
